<template>  
    <div id="profile" class="card card-body mt-4">
      <div class="row justify-content-center align-items-center">        
        <div class="col-sm-auto col-8 my-auto">
          <div class="h-100">
            <h5 class="mb-1 font-weight-bolder">{{ $t('location.UBN_number') }}: {{ state.ubn }}</h5>
            <p class="mb-0 font-weight-bold text-sm">
              {{ state.speciesIds }}
            </p>
          </div>
        </div>
        <div class="col-sm-auto ms-sm-auto mt-sm-0 mt-3 d-flex">          
        </div>
      </div>
    </div>    
    <div id="info" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header">
        <h5>{{ $t('location.Location_info') }}</h5>
        <p class="text-sm">{{ $t('location.Mandatory_informations') }} *</p>
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.UBN') }} *</label>
              <input v-model="state.ubn" type="text" class="form-control form-control-default" :placeholder="$t('location.UBN')">
              <span v-if="vLocationDetails$.ubn.$error" class="text-sm text-danger">
                {{ vLocationDetails$.ubn.$errors[0].$message }}
              </span>
            </div>
          </div>
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.Name') }}</label>
              <input v-model="state.name" type="text" class="form-control form-control-default" :placeholder="$t('location.Name')">
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-6">
            <div class="input-group input-group-static null">
                <label class="">{{ $t('location.Location_type') }} *</label>
                <select id="locationTypeId" v-model="state.locationTypeId" class="form-control form-control-default">
                  <option value="">{{ $t('location.Select_location_type') }}</option>
                  <option v-for="locationType in state.locationTypes" :key="locationType.id" :value="locationType.id">
                    {{ locationType.name }}
                  </option>
              </select>              
              <span v-if="vLocationDetails$.locationTypeId.$error" class="text-sm text-danger">
                {{ vLocationDetails$.locationTypeId.$errors[0].$message }}
              </span>
            </div>
          </div>
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.Keeper') }} *</label>
              <select id="keeperId" v-model="state.keeperId" class="form-control form-control-default">
                  <option value="">{{ $t('location.Select_keeper') }}</option>
                  <option v-for="keeper in state.keepers" :key="keeper.id" :value="keeper.id">
                    {{ keeper.fullname }}
                  </option>
              </select>
              <span v-if="vLocationDetails$.keeperId.$error" class="text-sm text-danger">
                  {{ vLocationDetails$.keeperId.$errors[0].$message }}
              </span>
            </div>
          </div>
        </div>
        <div class="row mt-3">        
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.Animal_type') }} *</label>
              <select id="animalTypeId" v-model="state.animalTypeId" class="form-control form-control-default custom-choices" multiple>
                <option value="">{{ $t('location.Select_animaltype') }}</option>
                <option v-for="item in state.animalTypes" :key="item.id" :value="item.id">
                  {{ item.name }}
                </option>
              </select>
              <span v-if="vLocationDetails$.animalTypeId.$error" class="text-sm text-danger">
                {{ vLocationDetails$.animalTypeId.$errors[0].$message }}
              </span>
            </div>
          </div>
          <div class="col-6">
            <div class="input-group input-group-static null" style="width: 200px;">
                <label class="">{{ $t('location.Max_animal_capicity') }}</label>
                <input v-model="state.maxAnimalCapacity" type="text" class="form-control form-control-default" :placeholder="$t('location.Max_animal_capicity')">   
                <span v-if="vLocationDetails$.maxAnimalCapacity.$error" class="text-sm text-danger">
                  {{ vLocationDetails$.maxAnimalCapacity.$errors[0].$message }}
                </span>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-12 mt-3">
          <button v-on:click="updateLocationinfo" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('location.Update_location_info') }}</button>
        </div>
      </div>
    </div>
    <div id="contact" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header">
        <h5>{{ $t('location.Contact_address_details') }}</h5>
        <p class="text-sm">{{ $t('location.Mandatory_informations') }} *</p>
      </div>
      <div class="card-body pt-0">   
        <div class="row">
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.E-mail') }}</label>
              <input v-model="state.email" type="text" class="form-control form-control-default" :placeholder="$t('location.E-mail')">            
            </div>  
          </div>               
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.Phone_number') }}</label>
              <input v-model="state.phoneNumber" type="text" class="form-control form-control-default" :placeholder="$t('location.Phone_number')">            
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-8">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.Address') }} *</label>
              <input v-model="state.street" type="text" class="form-control form-control-default" :placeholder="$t('location.Address')">
              <span v-if="vAddress$.street.$error" class="text-sm text-danger">
                {{ vAddress$.street.$errors[0].$message }}
              </span>
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.House_number') }} *</label>
              <input v-model="state.houseNumber" type="text" class="form-control form-control-default" :placeholder="$t('location.House_number')">
              <span v-if="vAddress$.houseNumber.$error" class="text-sm text-danger">
                {{ vAddress$.houseNumber.$errors[0].$message }}
              </span>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.Zipcode') }} *</label>
              <input v-model="state.postalCode" type="text" class="form-control form-control-default" :placeholder="$t('location.Zipcode')">
              <span v-if="vAddress$.postalCode.$error" class="text-sm text-danger">
                {{ vAddress$.postalCode.$errors[0].$message }}
              </span>
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.City') }} *</label>
              <input v-model="state.place" type="text" class="form-control form-control-default" :placeholder="$t('location.City')">
              <span v-if="vAddress$.place.$error" class="text-sm text-danger">
                {{ vAddress$.place.$errors[0].$message }}
              </span>
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.Country') }} *</label>
              <input v-model="state.country" type="text" class="form-control form-control-default" :placeholder="$t('location.Country')">
              <span v-if="vAddress$.country.$error" class="text-sm text-danger">
                {{ vAddress$.country.$errors[0].$message }}
              </span>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.Laitiude') }}</label>
              <input v-model="state.latitude" type="text" class="form-control form-control-default" :placeholder="$t('location.Laitiude')">
              <span v-if="vAddress$.latitude.$error" class="text-sm text-danger">
                {{ vAddress$.latitude.$errors[0].$message }}
              </span>
            </div>
          </div>      
          <div class="col-4">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.Longitude') }}</label>
              <input v-model="state.longitude" type="text" class="form-control form-control-default" :placeholder="$t('location.Longitude')">
              <span v-if="vAddress$.longitude.$error" class="text-sm text-danger">
                {{ vAddress$.longitude.$errors[0].$message }}
              </span>            
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-12 mt-3">
          <button v-on:click="updateContact" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('location.Update_contact') }}</button>
        </div>
      </div>
    </div>    
    <div id="rvo" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header pb-3">
        <h5>{{ $t('location.RVO') }}</h5>
        <p class="text-sm">{{ $t('location.Optional_information') }} *</p>
      </div>
      <div class="card-body pt-0">   
        <div class="row">
          <div class="col-5">
            <div class="input-group input-group-static null">
              <label class="d-block mb-1" style="width: inherit;">{{ $t('location.Verified') }}</label>
              <div class="d-block mt-1">
                <material-switch v-model="state.isRvoVerified" id="isRvoVerified" name="isRvoVerified" />
              </div>
            </div>
          </div>          
        </div>
        <div class="row mt-3">
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.Verifier') }} <small>{{ $t('location.Name_or_ID_of_the_verifier_internal_or_external') }}</small></label>
              <input v-model="state.rvoVerifier" type="text" class="form-control form-control-default" :placeholder="$t('location.Verifier')">            
            </div>
          </div>
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.Verification_method') }} <small>{{ $t('location.Method_used_API_sync_manual_entry_certificate') }}</small></label>
              <input v-model="state.rvoVerificationMethod" type="text" class="form-control form-control-default" :placeholder="$t('location.Verification_method')">            
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.Verification_source') }} <small>{{ $t('location.Source_system_eg_RVO_API_uploaded_doc') }}</small></label>
              <input v-model="state.rvoVerificationSource" type="text" class="form-control form-control-default" :placeholder="$t('location.Verification_source')">            
            </div>
          </div>
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.Certificate_number') }}</label>
              <input v-model="state.rvoCertificateNumber" type="text" class="form-control form-control-default" :placeholder="$t('location.Certificate_number')">            
            </div>
          </div>
        </div>
        <div class="row mt-3">
          
          <div class="col-4">
            <div class="input-group input-group-static null" style="width: 150px;">
              <label class="">{{ $t('location.Verification_date') }}</label>
              <input v-model="state.rvoVerificationDate" type="date" class="form-control form-control-default" :placeholder="$t('location.Verification_date')">            
            </div>
          </div>
          <div class="col-4">
            <div class="input-group input-group-static null" style="width: 150px;">
              <label class="">{{ $t('location.Expiry_date') }}</label>
              <input v-model="state.rvoExpiryDate" type="date" class="form-control form-control-default" :placeholder="$t('location.Expiry_date')">            
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12">         
            <label class="">{{ $t('location.Notes') }}</label>            
            <textarea
              v-model="state.rvoVerificationNotes"
              class="form-control custom-textarea"
              style="border: 1px solid #ced4da;"
              rows="3"
            ></textarea>          
        </div>
        </div>
        <div class="col-12 col-sm-12 mt-3">
          <button v-on:click="updateRVO" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('location.Update_RVO') }}</button>
        </div>
      </div>
    </div>
    <div id="toiler" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header">
        <h5>{{ $t('location.Toiler_disease_free') }}</h5>   
        <p class="text-sm">{{ $t('location.Optional_information') }}</p>
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="d-block mb-1" style="width: inherit;">{{ $t('location.Disease_free') }}</label>                  
              <div class="d-block mt-1">
                <material-switch v-model="state.isToilerDiseaseFree" id="isToilerDiseaseFree" name="isToilerDiseaseFree" />
              </div>
            </div>
          </div>               
          <div class="col-6">
            <div class="input-group input-group-static null" style="width: 150px;">
              <label class="">{{ $t('location.Lastcheck_date') }}</label>
              <input v-model="state.toilerDiseaseLastCheckDate" type="date" class="form-control form-control-default" :placeholder="$t('location.Lastcheck_date')">
              <span v-if="vToiler$.toilerDiseaseLastCheckDate.$error" class="text-sm text-danger">
                {{ vToiler$.toilerDiseaseLastCheckDate.$errors[0].$message }}
              </span>
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('location.Check_method') }} <small>Method of Toiler disease check (e.g., blood test)</small></label>
              <input v-model="state.toilerDiseaseCheckMethod" type="text" class="form-control form-control-default" :placeholder="$t('location.Check_method')">            
            </div>
          </div>
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="d-block mb-1" style="width: inherit;">{{ $t('location.Upload_certificate') }} </label>
              <div class="d-block mt-1">
                <input
                  type="file"               
                  accept=".pdf"
                  class=""
                  @change="handleFileUpload($event, 'toilerCertificateFile')"
                />                
                <a v-if="state.toilerCertificateFilePath" :href="state.toilerCertificateFilePath" target="_blank" download class="text-decoration-none">
                  <i class="material-symbols-rounded cursor-pointer text-primary" :title="$t('common.Download')">download</i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-12">
            <label class="">{{ $t('location.Notes') }} </label>
            <textarea
              v-model="state.toilerNotes"
              class="form-control custom-textarea"
              style="border: 1px solid #ced4da;"
              rows="3"
            ></textarea>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-12">
            <button v-on:click="updateToiler" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('location.Update_toiler_disease_free') }}</button>      
          </div>   
        </div>        
      </div>    
    </div>
    <div id="scrapie" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header">
        <h5>{{ $t('location.Scrapie') }}</h5>   
        <p class="text-sm">{{ $t('location.Optional_information') }}</p>
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="row">
            <div class="col-6">
              <div class="input-group input-group-static null">
                <label class="d-block mb-1" style="width: inherit;">{{ $t('location.Scrapie_certified') }}</label>                  
                <div class="d-block mt-1">
                  <material-switch v-model="state.hasScrapieCertificate" id="hasScrapieCertificate" name="hasScrapieCertificate" />
                </div>
              </div>
            </div>               
            <div class="col-6">
              <div class="input-group input-group-static null">
                <label class="">{{ $t('location.Certificate_number') }}</label>
                <input v-model="state.scrapieCertificateNumber" type="text" class="form-control form-control-default" :placeholder="$t('location.Certificate_number')">            
              </div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-6">
              <div class="input-group input-group-static null" style="width: 150px;">
                <label class="">{{ $t('location.Issued_date') }}</label>
                <input v-model="state.scrapieCertificateIssuedDate" type="date" class="form-control form-control-default" :placeholder="$t('location.Issued_date')">            
                <span v-if="vScrapie$.scrapieCertificateIssuedDate.$error" class="text-sm text-danger">
                  {{ vScrapie$.scrapieCertificateIssuedDate.$errors[0].$message }}
                </span>
              </div>
            </div>
            <div class="col-6">
              <div class="input-group input-group-static null" style="width: 150px;">
                <label class="">{{ $t('location.Expiry_date') }} </label>
                <input v-model="state.scrapieCertificateExpiryDate" type="date" class="form-control form-control-default" :placeholder="$t('location.Expiry_date')">
                <span v-if="vScrapie$.scrapieCertificateExpiryDate.$error" class="text-sm text-danger">
                  {{ vScrapie$.scrapieCertificateExpiryDate.$errors[0].$message }}
                </span>
              </div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-6">
              <div class="input-group input-group-static null">
                <label class="">{{ $t('location.Issued_by') }}</label>
                <input v-model="state.scrapieIssuedBy" type="text" class="form-control form-control-default" :placeholder="$t('location.Issued_by')">            
              </div>
            </div>
            <div class="col-6">
              <div class="input-group input-group-static null">
                <label class="">{{ $t('location.Verified_by') }} </label>
                <input v-model="state.scrapieVerifiedBy" type="text" class="form-control form-control-default" :placeholder="$t('location.Verified_by')">            
              </div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-6">
              <div class="input-group input-group-static null">
                <label class="d-block mb-1" style="width: inherit;">{{ $t('location.Upload_certificate') }}</label>
                <div class="d-block mt-1">
                  <input
                    type="file"               
                    accept=".pdf"
                    class=""
                    @change="handleFileUpload($event, 'scrapieCertificateFile')"
                  />                  
                  <a v-if="state.scrapieCertificateFilePath" :href="state.scrapieCertificateFilePath" target="_blank" download class="text-decoration-none">
                    <i class="material-symbols-rounded cursor-pointer text-primary" :title="$t('common.Download')">download</i>
                  </a>          
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="input-group input-group-static null">
                <label class="d-block mb-1" style="width: inherit;">{{ $t('location.Certificate_verified') }}</label>                  
                <div class="d-block mt-1">
                  <material-switch v-model="state.isScrapieCertificateVerified" id="isScrapieCertificateVerified" name="isScrapieCertificateVerified" />
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-12">
              <label class="">{{ $t('location.Notes') }} </label>
              <textarea
                v-model="state.scrapieNotes"
                class="form-control custom-textarea"
                style="border: 1px solid #ced4da;"
                rows="3"
              ></textarea>
            </div>        
          </div>      
        </div>
        <div class="row mt-4">
          <div class="col-12">
            <button v-on:click="updateScrapie" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('location.Update_scrapie') }}</button>      
          </div>   
        </div>        
      </div>    
    </div>
    <div id="delete" class="card mt-4" v-show="userRoleName == 'Admin' || userRoleName == 'AssociationAdmin'">
      <div class="card-header">
        <h5>{{ $t('common.Delete') }}</h5>
        <p class="text-sm mb-0">
          {{ $t('common.Once_you_delete_there_is_no_going_back_Please_be_certain') }}
        </p>
      </div>
      <div class="card-body d-sm-flex pt-0">
        <div class="d-flex align-items-center mb-sm-0 mb-4">
          <div>
            <material-switch id="deleteLocation" name="Delete member" @click="confirmDelete"/>
          </div>
          <div class="ms-2">
            <span class="text-dark font-weight-bold d-block text-sm">{{ $t('common.Confirm') }}</span>
            <span class="text-xs d-block">{{ $t('common.Delete_for') }} {{ state.location.ubn }}.</span>
          </div>
        </div>        
        <button class="btn mb-0 bg-gradient-danger btn-sm null null mb-0 ms-2" type="button" :disabled="!state.deleteLocation" @click="deleteLocation" name="button">{{ $t('location.Delete_location') }}</button>
      </div>
    </div>
  </template>
  
  <script>
  import MaterialSwitch from "@/components/MaterialSwitch.vue";
  import axios from 'axios'
  import { useVuelidate } from '@vuelidate/core'
  import { required, email as emailValidator, helpers, } from '@vuelidate/validators'
  import { reactive, computed } from 'vue'  
  import { useI18n } from 'vue-i18n'
  import Choices from 'choices.js';

  export default {
    name: "LocationDetailItem",
    computed: {    
        userRoleName() {
            return this.$store.state.user?.roleName;
        }        
    },
    setup() {
        
      const { t } = useI18n()

      const state = reactive ({
        location: [],
        locationTypes:[],
        keepers:[],
        animalTypes: [],
        gets: [],

        id: '',
        ubn: '',
        name: '',
        locationTypeId: '',
        keeperId: '',
        maxAnimalCapacity: null,
        animalTypeId: [],

        phoneNumber: '',
        email: '',
        street: '',
        houseNumber: '',
        place: '',
        postalCode: '',
        country: '',	
        latitude: '',
        longitude: '',

        isRvoVerified: false,
        rvoVerifier: '',                //Name or ID of the verifier (internal or external)
        rvoVerificationMethod: '',      //Method used (API sync, manual entry, certificate)
        rvoVerificationSource: '',      //Source system (e.g., RVO API, uploaded doc)
        rvoCertificateNumber: '',       //If applicable: a certificate or UBN document number
        rvoVerificationNotes: '',       //Any additional notes or comments from verifier

        currentLocationRvocertificate: [],
        locationRvocertificates: [],
        
        rvoLocationRvocertificateId: '',
        rvoVerificationDate: null,      //When verification was completed
        rvoExpiryDate: null,            //When verification expiry
        rvoUploaderFullName: '',
        rvoUploadedDateTime: null,

        isToilerDiseaseFree: false,         //-- Toiler Disease-Free  
        toilerDiseaseLastCheckDate: null,   //Last date of Toiler disease check
        toilerDiseaseCheckMethod: '',       //Method of Toiler disease check (e.g., blood test)
        toilerNotes: '',                    //Any additional notes
        toilerCertificateFilePath: '',      //Path to uploaded Toiler certificate
        toilerCertificateFile: null,

        hasScrapieCertificate: false,          //-- Scrapie Certificate
        scrapieCertificateNumber: '',          //-- Certificate number
        scrapieCertificateIssuedDate: null,    //When the certificate was issued
        scrapieCertificateExpiryDate: null,    //When the certificate expires
        scrapieIssuedBy: '',                   //Who issued the certificate (e.g., RVO)
        scrapieVerifiedBy: '',                 //Who verified it (system or user)
        isScrapieCertificateVerified: false,          
        scrapieNotes: '',                      //Any notes related to scrapie status
        scrapieCertificateFilePath: '',        //Path to uploaded Scrapie certificate  
        scrapieCertificateFile: null,

        deleteLocation: false
    })
    
    const integerOnly = helpers.withMessage(
      t('common.Integer_only'),
      value => {
        if (value === '' || value === null || value === undefined) return true; // allow empty
        return /^[0-9]+$/.test(value); // only allow integers
      }
    )
    
    const isLatitude = helpers.withMessage(
      t('location.Latitude_range'),
      value => {
        if (value === '' || value === null || value === undefined) return true;
        // Match only valid numbers (integer or decimal, optional sign)
        const numberRegex = /^-?\d+(\.\d+)?$/;
        if (!numberRegex.test(value)) return false;

        const num = parseFloat(value);
        return num >= -90 && num <= 90;
      }
    );

    const isLongitude = helpers.withMessage(
      t('location.Longitude_range'),
      value => {
        if (value === '' || value === null || value === undefined) return true;
        const numberRegex = /^-?\d+(\.\d+)?$/;
        if (!numberRegex.test(value)) return false;

        const num = parseFloat(value);
        return num >= -180 && num <= 180;
      }
    );

    const bothOrNone = helpers.withMessage(
      t('common.LatitudeLongitudePair'),
      helpers.withParams({ type: 'bothOrNone' }, (value, siblings) => {
        const lat = siblings.latitude;
        const lng = siblings.longitude;
        return (lat !== '' && lng !== '') || (lat === '' && lng === '');
      })
    );

    const rulesLocationDetails = computed(() => ({
      ubn: { required: helpers.withMessage(t('common.Required'), required) },
      locationTypeId: { 
          required: helpers.withMessage(t('common.Required'), required),
          isSelected: helpers.withMessage(t('location.Select_a_locationtype'), value => value !== '')
      },
      keeperId: { 
          required: helpers.withMessage(t('common.Required'), required),
          isSelected: helpers.withMessage(t('location.Select_a_keeper'), value => value !== '')
      },
      animalTypeId: { 
          required: helpers.withMessage(t('common.Required'), required),
          isSelected: helpers.withMessage(t('location.Select_animaltype'), value => value !== '')
      },
      maxAnimalCapacity: { integerOnly }
    }))

    const rulesAddress = computed(() => ({
      street: { required: helpers.withMessage(t('common.Required'), required) },
      houseNumber: { required: helpers.withMessage(t('common.Required'), required) },
      place: { required: helpers.withMessage(t('common.Required'), required) },
      postalCode: { required: helpers.withMessage(t('common.Required'), required) },
      country: { required: helpers.withMessage(t('common.Required'), required) },
      email: { 
        email: helpers.withMessage(t('common.Invalid_email_address'), emailValidator) 
      },
      latitude: {
        isLatitude,
        bothOrNone
      },
      longitude: {
        isLongitude,
        bothOrNone
      }
    }))

    const rulesToiler = computed(() => ({
      toilerDiseaseLastCheckDate: { required: helpers.withMessage(t('common.Required'), required) },
      toilerDiseaseLastCheckDate1: {
        requiredIfFile: helpers.withMessage(
          t('common.Toiler_disease_last_check_date_is_required'),
          (value) => {
            return !state.toilerCertificateFile || !!value;
          }
        )
      }
    }))

    const rulesScrapie = computed(() => ({
      scrapieCertificateIssuedDate: { required: helpers.withMessage(t('common.Required'), required) },
      scrapieCertificateExpiryDate: { required: helpers.withMessage(t('common.Required'), required) },
    }))
    
    const vLocationDetails$ = useVuelidate(rulesLocationDetails, state)
    const vAddress$ = useVuelidate(rulesAddress, state)
    const vToiler$ = useVuelidate(rulesToiler, state)
    const vScrapie$ = useVuelidate(rulesScrapie, state)

    return {
        state,
        vAddress$,
        vLocationDetails$,
        vToiler$,
        vScrapie$
    }
  },    
    components: {      
      MaterialSwitch,
    },    
    async mounted() {  
      this.id = this.$route.params.id;    
      await this.fetchLocationData(this.$route.params.id);
      
      await this.fetchAllLocationTypeData();
      await this.fetchAllKeeperData();
      await this.fetchAllAnimalTypesData();
    },
    methods: {      
      async fetchAllLocationTypeData() {
        try {                
            const response = await axios.get("reference/getreference?referenceTypeId=5977db02-0ac6-4dc7-ba44-edb5b0ab786e"); //Locationtype
            const result = response.data;

            if (result.success && Array.isArray(result.data)) {
                this.state.locationTypes = result.data;                        
                // Wait for DOM to update
                this.$nextTick(() => {
                    this.initializeChoicesLocationType(); // Initialize Choices here
                });
            } else {
                this.$showSuccess('errors.Error_fetching_locationtypes');
            }
            // Wait for DOM to update
            this.$nextTick(() => {
                this.initializeChoicesLocationType(); // Initialize Choices here
            });
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        }
      },
      initializeChoicesLocationType() {            
          const element = document.getElementById("locationTypeId");
          if (this.locationTypeChoicesInstance) {
              this.locationTypeChoicesInstance.destroy(); // Clean up previous instance
          }

          this.locationTypeChoicesInstance = new Choices(element, {
              searchEnabled: true,
              itemSelectText: '',
              shouldSort: false,
              placeholder: true, 
              //placeholderValue: '-- Select location type --', 
          });      

          if (this.state.locationTypeId) {
              const optionExists = this.state.locationTypes.some(locationType => locationType.id === this.state.locationTypeId);
              if (optionExists) {
                  this.locationTypeChoicesInstance.setChoiceByValue([this.state.locationTypeId]); // Set the selected value
              } else {
                  this.locationTypeChoicesInstance.setChoiceByValue(''); // Clear if no match found
              }
          }
      },
      async fetchAllKeeperData() {
          try {
              const response = await axios.get("user/getuser?role=keeper");
            const result = response.data;

            if (result.success && Array.isArray(result.data.userList)) {                        
                  this.state.keepers = result.data.userList;                       

                  // Wait for DOM to update
                  this.$nextTick(() => {
                      this.initializeChoicesKeeper(); // Initialize Choices here
                  });
              } else {
                this.$showError('errors.Error_fetching_keeper');                  
              }
          } catch (e) {                    
              const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
              this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
          }
      },
      initializeChoicesKeeper() {                    
          const element = document.getElementById("keeperId");
          if (this.keeperChoicesInstance) {
              this.keeperChoicesInstance.destroy(); // Clean up previous instance                    
          }
          
          this.keeperChoicesInstance  = new Choices(element, {
              searchEnabled: true,
              itemSelectText: '',
              shouldSort: false,
              placeholder: true, 
              //placeholderValue: '-- Select keeper --', 
          });      

          if (this.state.keeperId) {
              const optionExists = this.state.keepers.some(keeper => keeper.id === this.state.keeperId);
              if (optionExists) {
                  this.keeperChoicesInstance.setChoiceByValue([this.state.keeperId]); // Set the selected value
              } else {
                  this.keeperChoicesInstance.setChoiceByValue(''); // Clear if no match found
              }
          }
      },
      async fetchAllAnimalTypesData() {
        try {
          const response = await axios.get("reference/getreference?referenceTypeId=b81c5e43-3e52-49b4-9205-57330f75c3d1"); //AnimalType
          const result = response.data;

          if (result.success && Array.isArray(result.data)) {
            this.state.animalTypes = result.data;

            //Convert animalTypeId to array
            if (typeof this.state.animalTypeId === 'string') {
              this.state.animalTypeId = this.state.animalTypeId
                ? this.state.animalTypeId.split(',').map(x => x.trim())
                : [];
            }

            this.$nextTick(() => {
              this.initializeChoicesAnimalTypes();
            });
          } else {
            this.$showError('errors.Contact_system_admin');
          }
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        }
      },
      initializeChoicesAnimalTypes() {                    
          const element = document.getElementById("animalTypeId");
          if (this.animalTypeChoicesInstance) {
              this.animalTypeChoicesInstance.destroy(); // Clean up previous instance                    
          }
          
          this.animalTypeChoicesInstance  = new Choices(element, {
            removeItemButton: true,
            searchEnabled: true,
            itemSelectText: '',
            shouldSort: false,
            placeholder: true,  
            //placeholderValue: '-- Select animalType --', 
          });      

          // Sync selected values if already chosen
          if (Array.isArray(this.state.animalTypeId)) {
            const validValues = this.state.animalTypeId.filter(id =>
              this.state.animalTypes.some(item => item.id === id)
            );

            this.animalTypeChoicesInstance.setChoiceByValue(validValues);
          }
      },
      async fetchLocationData(locationId) {
        try {
            
            this.$store.commit('setShowLoading', true);

            const response = await axios.get(`Location/${locationId}`);
            this.gets = response.data;
            
            if (this.gets.success) {
                this.state.location = this.gets.data;

                this.state.id = this.state.location.id;
                this.state.ubn = this.state.location.ubn;
                this.state.name = this.state.location.name;
                this.state.locationTypeId = this.state.location.locationTypeId;
                this.state.keeperId = this.state.location.keeperId;
                this.state.maxAnimalCapacity = this.state.location.maxAnimalCapacity;
                this.state.animalTypeId = this.state.location.animalTypeId;

                this.state.phoneNumber = this.state.location.phoneNumber;
                this.state.email = this.state.location.email;
                this.state.street = this.state.location.street;
                this.state.houseNumber = this.state.location.houseNumber;
                this.state.place = this.state.location.place;
                this.state.postalCode = this.state.location.postalCode;
                this.state.country = this.state.location.country;
                this.state.latitude = this.state.location.latitude;
                this.state.longitude = this.state.location.longitude;

                this.state.isRvoVerified = this.state.location.isRvoVerified;                
                this.state.rvoVerifier = this.state.location.rvoVerifier;
                this.state.rvoVerificationMethod = this.state.location.rvoVerificationMethod;
                this.state.rvoVerificationSource = this.state.location.rvoVerificationSource;
                this.state.rvoCertificateNumber = this.state.location.rvoCertificateNumber;
                this.state.rvoVerificationNotes = this.state.location.rvoVerificationNotes;
                
                this.state.currentLocationRvocertificate = this.state.location.currentLocationRvocertificate;
                this.state.locationRvocertificates = this.state.location.locationRvocertificates;
                
                if(this.state.location.currentLocationRvocertificate != null) {
                  this.state.rvoLocationRvocertificateId = this.state.currentLocationRvocertificate.id;
                  this.state.rvoVerificationDate = this.state.currentLocationRvocertificate.rvoVerificationDate;
                  this.state.rvoExpiryDate = this.state.currentLocationRvocertificate.rvoExpiryDate;
                  this.state.rvoUploaderFullName = this.state.currentLocationRvocertificate.fulName;
                  this.state.rvoUploadedDateTime = this.state.currentLocationRvocertificate.uploaded;
                }

                this.state.isToilerDiseaseFree = this.state.location.isToilerDiseaseFree;
                this.state.toilerDiseaseLastCheckDate = this.state.location.toilerDiseaseLastCheckDate;
                this.state.toilerDiseaseCheckMethod = this.state.location.toilerDiseaseCheckMethod;
                this.state.toilerNotes = this.state.location.toilerNotes;
                this.state.toilerCertificateFilePath = this.state.location.toilerCertificateFilePath;

                this.state.hasScrapieCertificate = this.state.location.hasScrapieCertificate;
                this.state.scrapieCertificateNumber = this.state.location.scrapieCertificateNumber;
                this.state.scrapieCertificateIssuedDate = this.state.location.scrapieCertificateIssuedDate;
                this.state.scrapieCertificateExpiryDate = this.state.location.scrapieCertificateExpiryDate;
                this.state.scrapieIssuedBy = this.state.location.scrapieIssuedBy;
                this.state.scrapieVerifiedBy = this.state.location.scrapieVerifiedBy;
                this.state.isScrapieCertificateVerified = this.state.location.isScrapieCertificateVerified;
                this.state.scrapieNotes = this.state.location.scrapieNotes;
                this.state.scrapieCertificateFilePath = this.state.location.scrapieCertificateFilePath;
                
            } else {
              this.$showError('errors.Contact_system_admin');
            }
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        }
        
        this.$store.commit('setShowLoading', false);
      },    
      async updateLocationinfo() {   
        try {
            this.$store.commit('setShowLoading', true);

            this.vLocationDetails$.$validate();                
            //console.log(this.vLocationDetails$.$error);
            
            if(!this.vLocationDetails$.$error) {     
                const commaSeparatedAnimalTypeId = this.state.animalTypeId.join(',');
              
                const response = await axios.put('Location/updatelocationinfo', {
                  "id": this.state.id,
                  "ubn": this.state.ubn,
                  "name": this.state.name,
                  "locationTypeId": this.state.locationTypeId,
                  "keeperId": this.state.keeperId,
                  "maxAnimalCapacity": this.state.maxAnimalCapacity,
                  "animalTypeId": commaSeparatedAnimalTypeId
                  });
                this.gets = response.data;

                if (this.gets.success) {
                  this.$showSuccess('errors.Success_locationinfo_updated_successfully');
                  
                  this.$router.push({ path: `/location/edit/${this.state.id}` }).then(() => {
                    this.fetchLocationData(this.state.id); // Trigger data refresh or any required action
                  });
                } else {
                  this.$showError('errors.Contact_system_admin');
                }
            }
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        }                        
        this.$store.commit('setShowLoading', false);
      },
      async updateContact() {   
        try {
            this.$store.commit('setShowLoading', true);

            this.vAddress$.$validate();
            //console.log(this.vAddress$.$error);
            
            if(!this.vAddress$.$error) {     
                const response = await axios.put('Location/updateaddress', {
                  "id": this.state.id,
                  "phoneNumber": this.state.phoneNumber,
                  "email": this.state.email,
                  "street": this.state.street,
                  "houseNumber": this.state.houseNumber,
                  "place": this.state.place,
                  "postalCode": this.state.postalCode,
                  "country": this.state.country,
                  "latitude": this.state.latitude,
                  "longitude": this.state.longitude
                });
                this.gets = response.data;

                if (this.gets.success) {
                  this.$showSuccess('errors.Success_contact_address_details_updated_successfully');
                  
                  this.$router.push({ path: `/location/edit/${this.state.id}` }).then(() => {
                    this.fetchLocationData(this.state.id); // Trigger data refresh or any required action
                  });
                } else {
                  this.$showError('errors.Contact_system_admin');
                }
            }
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        }                        
        this.$store.commit('setShowLoading', false);
      },
      async updateRVO() {   
        try {
            this.$store.commit('setShowLoading', true);
                        
            const response = await axios.put('Location/updatervo', {                  
              "id": this.state.id,
              "isRvoVerified": this.state.isRvoVerified,              
              "rvoVerifier": this.state.rvoVerifier,
              "rvoVerificationMethod": this.state.rvoVerificationMethod,
              "rvoVerificationSource": this.state.rvoVerificationSource,
              "rvoCertificateNumber": this.state.rvoCertificateNumber,
              "rvoVerificationNotes": this.state.rvoVerificationNotes,

              "rvoLocationRvocertificateId": this.state.rvoLocationRvocertificateId,
              "rvoVerificationDate": this.state.rvoVerificationDate,
              "rvoExpiryDate": this.state.rvoExpiryDate
            });
            this.gets = response.data;

            if (this.gets.success) {
              this.$showSuccess('errors.Success_rvo_updated_successfully');
              
              this.$router.push({ path: `/location/edit/${this.state.id}` }).then(() => {
                this.fetchLocationData(this.state.id); // Trigger data refresh or any required action
              });
            } else {
              this.$showError('errors.Contact_system_admin');
            }
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        }                        
        this.$store.commit('setShowLoading', false);
      },
      async updateToiler() {
        try {
          this.$store.commit('setShowLoading', true);

          this.vToiler$.$validate();
            //console.log(this.vAddress$.$error);
            
          if(!this.vToiler$.$error) {

            const formData = new FormData();
            formData.append("id", this.state.id);
            formData.append("isToilerDiseaseFree", this.state.isToilerDiseaseFree);
            formData.append("toilerDiseaseLastCheckDate", this.state.toilerDiseaseLastCheckDate);
            formData.append("toilerDiseaseCheckMethod", this.state.toilerDiseaseCheckMethod);
            formData.append("toilerNotes", this.state.toilerNotes);

            if (this.state.toilerCertificateFile) {
              formData.append("toilerCertificateFile", this.state.toilerCertificateFile);
            }

            const response = await axios.put('Location/updatetoiler', formData, {
              headers: { 'Content-Type': 'multipart/form-data' }
            });

            this.gets = response.data;

            if (this.gets.success) {
              this.$showSuccess('errors.Success_toiler_disease_free_updated_successfully');
              
              this.$router.push({ path: `/location/edit/${this.state.id}` }).then(() => {
                this.fetchLocationData(this.state.id);
              });
            } else {
              this.$showError('errors.Contact_system_admin');
            }
          }
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        } finally {
          this.$store.commit('setShowLoading', false);
        }
      },
      async updateScrapie() {
        try {
          this.$store.commit('setShowLoading', true);

          this.vScrapie$.$validate();
            //console.log(this.vAddress$.$error);
            
          if(!this.vScrapie$.$error) {            
            const formData = new FormData();
            formData.append("id", this.state.id);
            formData.append("hasScrapieCertificate", this.state.hasScrapieCertificate);
            formData.append("scrapieCertificateNumber", this.state.scrapieCertificateNumber);
            formData.append("scrapieCertificateIssuedDate", this.state.scrapieCertificateIssuedDate);
            formData.append("scrapieCertificateExpiryDate", this.state.scrapieCertificateExpiryDate);
            formData.append("scrapieIssuedBy", this.state.scrapieIssuedBy);
            formData.append("scrapieVerifiedBy", this.state.scrapieVerifiedBy);
            formData.append("isScrapieCertificateVerified", this.state.isScrapieCertificateVerified);
            formData.append("scrapieNotes", this.state.scrapieNotes);

            if (this.state.scrapieCertificateFile) {
              formData.append("scrapieCertificateFile", this.state.scrapieCertificateFile);
            }

            const response = await axios.put('Location/updatescrapie', formData, {
              headers: { 'Content-Type': 'multipart/form-data' }
            });

            this.gets = response.data;

            if (this.gets.success) {
              this.$showSuccess('errors.Success_scrapie_updated_successfully');
              
              this.$router.push({ path: `/location/edit/${this.state.id}` }).then(() => {
                this.fetchLocationData(this.state.id);
              });
            } else {
              this.$showError('errors.Contact_system_admin');
            }
          }
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        }

        this.$store.commit('setShowLoading', false);
      },      
      handleFileUpload(event, fieldName) {
        const file = event.target.files[0];
        if (file && fieldName === 'toilerCertificateFile') {
          this.state.toilerCertificateFile = file;
          this.state.toilerCertificateFilePath = file.name;
        } else if (file && fieldName === 'scrapieCertificateFile') {
          this.state.scrapieCertificateFile = file;
          this.state.scrapieCertificateFilePath = file.name;
        }
      },
      confirmDelete() {
        this.state.deleteLocation = !this.state.deleteLocation;
      },      
      deleteLocation() {
        if (this.state.deleteLocation) {
          this.deleteLocation1(this.state.id)
        }
      },                  
      async deleteLocation1(id) {   
        try {
            
            this.$store.commit('setShowLoading', true);

            const response = await axios.delete("Location/" + id);
            this.gets = response.data;

            if (this.gets.success) {
              this.$showSuccess('errors.Success_location_deleted_successfully');
              
              this.$router.push('/location');                
            } else {
              this.$showError('errors.Contact_system_admin');
            }
        } catch (e) {
          const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
          this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        }         
      }
    }
  };
  </script>
  <style scoped>
  .custom-textarea {
    border: 1px solid #ced4da;
    border-radius: 4px;
    padding: 0.5rem;  
  }
  </style>